import React from 'react';
import PropTypes from 'prop-types';
import { useParams, useLocation } from 'react-router-dom';

import CategoryDynPage from 'components/consumer/CategoryPage';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';

const getFinalSlug = (pathName, slug) => {
  if (pathName.includes('mid-century-furniture')) {
    return `mid-century-furniture/${slug}`;
  }

  if (pathName.includes('small-space-furniture')) {
    return `small-space-furniture/${slug}`;
  }

  if (pathName.includes('modern')) {
    return `modern/${slug}`;
  }

  if (pathName.includes('new')) {
    return `new/${slug}`;
  }

  return `/${slug}`;
};

const SpecialCategoryWrapper = props => {
  const { isAdmin } = props;
  const location = useLocation();
  const { slug } = useParams();
  const finalSlug = getFinalSlug(location.pathname, slug);

  if (isAdmin) {
    return (
      <AdminPlaceholder>
        Special Category Wrapper Placeholder for Variant Builder. <br />
        This component is not editable and will display contents based on URL in
        consumer
      </AdminPlaceholder>
    );
  }

  return <CategoryDynPage slug={finalSlug} />;
};

SpecialCategoryWrapper.propTypes = {
  isAdmin: PropTypes.bool,
};

export default SpecialCategoryWrapper;
